import type { ThemeOptions as MuiThemeOptions } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import deepmerge from 'deepmerge';
import createDefault from './theme';
import { ptBR } from './theme/locales';
import overrides from './theme/overrides';
import * as props from './theme/props';
import { Theme } from './theme/types';

export interface ThemeOptions extends MuiThemeOptions {
    shellMode?: 'light' | 'dark';
}

const createThemeOverride = (themeOptions: ThemeOptions = {}, args: object = ptBR): Theme => {
    const { palette: paletteInput = {}, shellMode = 'light', ...rest } = themeOptions;

    const theme = createDefault(createTheme(themeOptions, args) as Theme);

    const {
        error = theme.palette.error,
        grey = theme.palette.grey,
        info = theme.palette.info,
        primary = theme.palette.primary,
        secondary = theme.palette.secondary,
        success = theme.palette.success,
        warning = theme.palette.warning,
        type = 'light',
    } = paletteInput;

    const light = {
        background: theme.palette.background,
        divider: theme.palette.divider,
        text: theme.palette.text,
    };

    const dark = {
        secondary: { main: theme.palette.grey[300] },
        background: {
            paper: theme.palette.grey[900],
            default: theme.palette.grey[800],
        },
    };

    /**
     * @deprecated - not used in the new design.
     */
    const shell = theme.palette.shell;

    const types = { dark, light };

    const palette = {
        error,
        grey,
        info,
        primary,
        secondary,
        success,
        warning,
        type,
        shell,
        ...types[type],
    };

    const outerTheme = deepmerge(
        {
            ...theme,
            overrides: overrides(theme),
            palette,
            shellMode,
            props,
        },
        rest,
    );

    return createTheme(outerTheme, args) as Theme;
};

export const DEFAULT_THEME = createThemeOverride();

export default createThemeOverride;
